import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;

export interface SjwArtifactPhoto {
  data_file_id: string;
  original_filename: string | null;
  file_status: string;
}

export interface SjwSchoolArtifact {
  artifact_name: string;
  photos: SjwArtifactPhoto[];
}

export interface SjwSchoolPhotoUploadResponse {
  artifacts: SjwSchoolArtifact[];
  status: 'NOT_STARTED' | 'IN_PROGRESS' | 'COMPLETE';
}

export interface SjwSchoolSummary {
  school_id: string;
  school_name: string;
  status: 'NOT_STARTED' | 'IN_PROGRESS' | 'COMPLETE';
  due_date: string | null;
}

export interface SjwPhotoUploadSchoolsResponse {
  schools: SjwSchoolSummary[];
}

const getSjwPhotoUploadSchools = async (eoaId: string, accessToken: string): Promise<SjwPhotoUploadSchoolsResponse> => {
  const response = await axios.get<SjwPhotoUploadSchoolsResponse>(`${BASE_URL}/eoa/${eoaId}/schools/sjw-photo-upload`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return response.data;
};

const getSjwSchoolPhotoUpload = async (
  eoaId: string,
  accessToken: string,
  schoolId: string
): Promise<SjwSchoolPhotoUploadResponse> => {
  const response = await axios.get<SjwSchoolPhotoUploadResponse>(
    `${BASE_URL}/eoa/${eoaId}/schools/${schoolId}/sjw-photo-upload`,
    { headers: { Authorization: `Bearer ${accessToken}` } }
  );
  return response.data;
};

const markSjwPhotoUploadComplete = async (eoaId: string, accessToken: string, schoolId: string) => {
  return await axios.post(`${BASE_URL}/eoa/${eoaId}/schools/${schoolId}/sjw-photo-upload/complete`, null, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
};

const deleteSjwArtifactPhoto = async (eoaId: string, accessToken: string, schoolId: string, dataFileId: string) => {
  return await axios.delete(`${BASE_URL}/eoa/${eoaId}/schools/${schoolId}/sjw-artifact-photos/${dataFileId}`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
};

export { getSjwSchoolPhotoUpload, getSjwPhotoUploadSchools, markSjwPhotoUploadComplete, deleteSjwArtifactPhoto };
